const currencyFormat = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

const amountInputFormat = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const toEuros = (cents) => {
  const value = Number(cents);
  return Number.isFinite(value) ? value / 100 : 0;
};

const formatCents = (cents) => currencyFormat.format(toEuros(cents));

const formatAmountInput = (cents) =>
  amountInputFormat.format(toEuros(cents));

const countLabel = (count, one, many) =>
  `${count} ${count === 1 ? one : many}`;

module.exports = {
  formatCents,
  formatAmountInput,
  countLabel,
};
